import { cookies } from '@/lib/cookies.js';

const functionalValue = '1';
const advertisingValue = '2';

export function getConsent(cookieString) {
  const behaviourCookie = cookies.getCookieFromString(cookieString, 'notice_behavior');
  const preferences = cookies.getCookieFromString(cookieString, 'notice_gdpr_prefs') || '';

  let loadFunctional = false;
  let loadAdvertising = false;

  if (behaviourCookie) {
    const [consent, region] = behaviourCookie.split(',').slice(0, 2);

    // IF a user is in Implied Consent Behavior AND without the consent, apply the Zero Cookie Load (only the required trackers will fire)
    if (consent === 'implied' && region === 'eu') {
      const prefArray = preferences.split(/[,:]+/);
      loadFunctional = !!prefArray.find((element) => element === functionalValue);
      loadAdvertising = !!prefArray.find((element) => element === advertisingValue);

      // ELSE, the user is in a non-provisioned country, fire all the tags .
    } else {
      loadFunctional = true;
      loadAdvertising = true;
    }
  }

  return {
    loadFunctional,
    loadAdvertising,
  };
}
